module.exports = __webpack_public_path__ + "static/media/pro_4.841eb583.jpg";